import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import Select from 'react-select';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';
import {
  SELECT_LABELS,
  getSelectOptionValue,
  selectPlaceholder,
  withSelectPlaceholder,
} from '../../services/selectOptions';
import {
  loadIndexPage,
  parseIndexPageResponse,
} from '../../services/mdServerIndex';

const SELECT_CLASS_NAMES = {
  control: () => 'md-form-page__select__control',
};

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

export class ActualizarRegularidades extends Component {
  static displayName = ActualizarRegularidades.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingInitial: true,
      loadError: '',
      errorMessage: '',
      redirect: false,
      valueCarrera: selectPlaceholder(SELECT_LABELS.carreraAcademica),
      carreraCod: '',
      carreraOptions: withSelectPlaceholder([], SELECT_LABELS.carreraAcademica),
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    constantClass.canAccess('HistoriaAcademicaCursada');
    this.loadCarreraOptions();
  }

  async loadCarreraOptions() {
    this.setState({ loadingInitial: true, loadError: '' });

    const pageSize = 100;
    let page = 0;
    let items = [];
    let totalCount = 0;

    while (page === 0 || items.length < totalCount) {
      const data = await loadIndexPage('api/Carreras/Index', page, pageSize, '');
      const parsed = parseIndexPageResponse(
        data,
        'No tiene permiso para consultar las carreras.'
      );

      if (parsed.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }

      if (parsed.type === 'error') {
        this.setState({ loadingInitial: false, loadError: parsed.message });
        return;
      }

      items = items.concat(parsed.items);
      totalCount = parsed.totalCount;
      page += 1;

      if (parsed.items.length === 0) {
        break;
      }
    }

    const options = items
      .map((carrera) => ({
        value: String(carrera.carreraCod),
        label: carrera.carreraNombre,
      }))
      .sort((a, b) => a.label.localeCompare(b.label, 'es'));

    this.setState({
      loadingInitial: false,
      carreraOptions: withSelectPlaceholder(options, SELECT_LABELS.carreraAcademica),
    });
  }

  clearFeedback() {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: '' });
    }
  }

  handleCarreraChange = (option) => {
    this.clearFeedback();
    const value = option && option.value ? option.value : '';
    this.setState({ valueCarrera: option, carreraCod: value });
  };

  isFormValid() {
    return Boolean(getSelectOptionValue(this.state.valueCarrera, this.state.carreraCod));
  }

  handleSubmit(e) {
    e.preventDefault();
    if (isSubmitInProgress(this.state.loading)) return;
    if (!this.isFormValid()) {
      this.setState({ errorMessage: 'Debe seleccionar una carrera.' });
      return;
    }
    this.runUpdate();
  }

  async runUpdate() {
    if (isSubmitInProgress(this.state.loading)) return;

    const carreraCod = getSelectOptionValue(this.state.valueCarrera, this.state.carreraCod);
    this.setState({ loading: true, errorMessage: '' });

    const { data } = await constantClass.apiFetch('api/ic/actcur/' + carreraCod, {
      method: 'POST',
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data) || data.returnModel === false) {
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudieron actualizar las regularidades. Intente nuevamente.'
        ),
      });
      return;
    }

    this.setState({ loading: false, redirect: true });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/md-hic" />;
    }

    const { loading, loadingInitial, loadError, errorMessage, valueCarrera, carreraOptions } = this.state;
    const isBusy = loading || loadingInitial;

    return (
      <div className="md-page md-form-page md-actualizar-regularidades">
        <Link className="md-form-page__back" to="/md-hic">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 className="md-form-page__title">Actualizar Regularidades por Carrera</h1>
        <p className="md-form-page__subtitle">
          Seleccione la carrera y ejecute la actualización de fechas de vencimiento de regularidad.
        </p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {loadError ? (
                <span className="md-form-page__error" role="alert">{loadError}</span>
              ) : null}
              {errorMessage ? (
                <span className="md-form-page__error" role="alert">{errorMessage}</span>
              ) : null}
              {loadingInitial ? (
                <span className="md-form-page__loading">Cargando carreras, espere un momento...</span>
              ) : null}
              {loading ? (
                <span className="md-form-page__loading">Actualizando regularidades, espere un momento...</span>
              ) : null}
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="accur-carrera">
                Carrera
              </label>
              <div className="md-form-page__select-wrap">
                <Select
                  inputId="accur-carrera"
                  classNamePrefix="md-form-page__select"
                  classNames={SELECT_CLASS_NAMES}
                  value={valueCarrera}
                  options={carreraOptions}
                  onChange={this.handleCarreraChange}
                  isDisabled={isBusy}
                />
              </div>
            </div>

            <div className="md-form-page__actions">
              <button
                type="submit"
                className="md-form-page__btn md-form-page__btn--primary"
                disabled={isBusy}
              >
                {loading ? 'Actualizando...' : 'Actualizar regularidades'}
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
